import angular from 'angular';
import moment from 'moment';

(function() {
  'use strict';
  angular.module('app.core').factory('UtilSvc', UtilSvc);

  UtilSvc.$inject = ['$filter'];

  /* @ngInject */

  function UtilSvc($filter) {
    var exports = {
      getDateForExportName: getDateForExportName,
      splitMail: splitMail,
      joinMail: joinMail,
      parseDate: parseDate,
      parseJson: parseJson,
      stringifyObject: stringifyObject,
      mixteDateTime: mixteDateTime,
      formatDomainNames: formatDomainNames
    };

    return exports;

    //////////////////////////
    /**
     * Formattage de la date pour les exports
     */
    function getDateForExportName() {
      return $filter('date')(new Date(), 'dd-MM-yyyy_HH-mm-ss');
    }

    /**
     * Permet de spliter la liste des adresses mail séparées par une ;
     * @return tableau de mails
     */
    function splitMail(mail) {
      if (mail) {
        var tagsMail = [];
        var splittedMail = mail.split(';');
        var splitLength = splittedMail.length;
        for (var idx = 0; idx < splitLength; idx++) {
          tagsMail.push({ text: splittedMail[idx].trim() });
        }
        return tagsMail;
      }
      return null;
    }

    /**
     * Permet de construire la liste des mails séparées par une ; à partir du tableau des mails.
     */
    function joinMail(tagsMail) {
      if (tagsMail) {
        var mailLength = tagsMail.length;
        var mail = '';
        for (var idx = 0; idx < mailLength; idx++) {
          mail += tagsMail[idx].text + ';';
        }
        return mail.substring(0, mail.length - 1);
      }
      return null;
    }

    function formatDomainNames(domainTags){
        if (domainTags) {
            return domainTags.map(tag => tag.text);
        }
        return null;
    }

    function parseDate(date) {
      if (date) {
        return moment(date).toDate();
      }
      return null;
    }

    function parseJson(json) {
      return json ? JSON.parse(json) : null;
    }

    function stringifyObject(object) {
      return object ? JSON.stringify(object) : null;
    }

    /**
     * Mixte la date et l'heure dans la même datetime.
     */
    function mixteDateTime(date, time) {
      var datetime;
      if (date) {
        datetime = date;
        if (time) {
          datetime.setHours(time.getHours());
          datetime.setMinutes(time.getMinutes());
        }
      }
      return datetime;
    }
  }
})();
